import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

import { WORCarrierState } from "@tKgpco/Store/Data/WOR/WORCarrierState";

const initialState: WORCarrierState = {
    isLoading: false,
    carriers: [],
};
export const reducer = {
    "Custom/WORCarriers/BeginLoad": (draft: Draft<WORCarrierState>) => {
        draft.isLoading = true;
    },
    "Custom/WORCarriers/CompleteLoad": (draft: Draft<WORCarrierState>, action: WORCarrierState) => {
        draft.isLoading = false;
        draft.carriers = action.carriers;
    },
    "Custom/WORCarriers/FailedToLoadCarriers": (draft: Draft<WORCarrierState>) => {
        draft.isLoading = false;
        draft.carriers = [];
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
